import { defineSlotRecipe } from '@chakra-ui/react';
import 'video-react/dist/video-react.css';
import { BaseBodyP3, FontFamilyDefault, LineHeights5xl, TextInvertSubdued } from '../../generated/variables';

// VideoPlayer/component.tsx reads only playToggleButton/timeDisplay/progressControl/
// volumeButton/closedCaptionButton/fullscreenToggle via useRecipe; no other slot is consumed.
export const videoPlayerSlotRecipe = defineSlotRecipe({
  slots: [
    'volumeButton',
    'closedCaptionButton',
    'playToggleButton',
    'timeDisplay',
    'progressControl',
    'fullscreenToggle',
  ],
  base: {
    playToggleButton: {
      color: `${TextInvertSubdued} !important`,
    },
    timeDisplay: {
      fontSize: `${BaseBodyP3} !important`,
      lineHeight: `${LineHeights5xl} !important`,
      fontFamily: `${FontFamilyDefault} !important`,
    },
  },
});
